var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"single-actions":_vm.singleActions}})
}
var staticRenderFns = []

export { render, staticRenderFns }